import { useEffect, useState } from "react";
import { bool, func, node, string } from "prop-types";

import Dropdown from "@shared/v2/Dropdown";
import { CheckboxGroupHeading, CheckboxOption } from "@shared/v2/Dropdown/custom/MultiComponents";
import { useEventListenerAction } from "@shared/hooks/useEventListenerAction";

// This component is used to create a dropdown with multi select and controlled removable options *REUSABLE
const DropdownWithMultiCtrlledRemovable = ({
  ctrlName,
  options,
  selectedOptions,
  removablePrefix,
  placeHolderTxt,
  dropdownClassName,
  dropdownMultiValueClassName,
  placeholderNoSelected,
  placeholder,
  isSearchable,
  isRequired,
  onChange,
  onBlur,
  label,
  eventListenerId,
  OptionComponent,
  ...props
}) => {
  const [withMultiValue, setWithMultiValue] = useState([]);
  useEventListenerAction(eventListenerId, () => setWithMultiValue([]));

  useEffect(() => {
    setWithMultiValue(selectedOptions);
  }, [selectedOptions]);

  useEffect(() => {
    Brivity.ClearAllFiltersButton?.toggle();
  }, [selectedOptions, withMultiValue]);

  const placeHolderText =
    withMultiValue.length > 0 ? `${withMultiValue.length}${placeHolderTxt}` : placeholderNoSelected;

  return (
    <>
      <Dropdown
        isMulti
        placeholder={placeholder || placeHolderText}
        options={options}
        value={withMultiValue}
        label={label}
        blurInputOnSelect={false}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        className={dropdownClassName}
        dropdownMultiValueClassName={dropdownMultiValueClassName}
        onChange={(newValue) => {
          setWithMultiValue(newValue);
          onChange(newValue);
        }}
        onBlur={onBlur}
        removablePrefix={removablePrefix}
        components={{
          GroupHeading: CheckboxGroupHeading,
          Option: OptionComponent,
        }}
        isSearchable={isSearchable}
        name={ctrlName}
        backspaceRemovesValue={false}
        isRequired={isRequired}
        preventOptionUpdate
        {...props}
      />
    </>
  );
};

export default DropdownWithMultiCtrlledRemovable;

DropdownWithMultiCtrlledRemovable.propTypes = {
  removablePrefix: string,
  placeHolderTxt: string,
  label: string,
  dropdownClassName: string,
  isSearchable: bool,
  onChange: func,
  onBlur: func,
  isRequired: bool,
  dropdownMultiValueClassName: string,
  placeholderNoSelected: string,
  placeholder: node,
  eventListenerId: string,
  OptionComponent: func,
};

DropdownWithMultiCtrlledRemovable.defaultProps = {
  removablePrefix: "",
  placeHolderTxt: "",
  placeholder: null,
  label: "",
  dropdownClassName: "",
  options: [],
  selectedOptions: [],
  isSearchable: true,
  onChange: () => {},
  onBlur: () => {},
  isRequired: false,
  dropdownMultiValueClassName: "!tw-text-[12d] !tw-font-normal",
  placeholderNoSelected: "Select",
  eventListenerId: "#clear-all-modal-filters",
  OptionComponent: CheckboxOption,
};
